import useActiveNavigation from '@UI/Guidelines/Shell/AppShell/Hooks/useActiveNavigation';
import { HomeBreadcrumb } from '@verclam/breadcrumbs';
import * as React from 'react';

const ICON_SIZE = 16;

/** The only `HomeBreadcrumb` of the application: the active entry opens the trail. */
const NavigationHomeBreadcrumb: React.FC = () => {
	const active = useActiveNavigation();
	const EntryIcon = active?.entry.icon;

	// The icon component is a stable module reference; a fresh node on every render would re-register the home item.
	const icon = React.useMemo(
		() => (EntryIcon === undefined ? null : <EntryIcon size={ICON_SIZE} aria-hidden="true" />),
		[EntryIcon],
	);

	if (active === null || icon === null) {
		return null;
	}

	return <HomeBreadcrumb url={active.destination.path} label={active.entry.label} icon={icon} />;
};

export default NavigationHomeBreadcrumb;
